import PageHero from "@/components/layout/PageHero";
import Gallery from "@/components/sections/Gallery";

const Galeria = () => (
  <>
    <PageHero
      eyebrow="Nosso portfólio"
      title="Galeria de Trabalhos"
      description="Conheça alguns dos nossos trabalhos de acabamento gráfico. Qualidade que você pode ver em cada detalhe."
    />
    <Gallery showHeading={false} />
  </>
);

export default Galeria;
